import { Button, SxProps, Tooltip } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../../legacy/style/theme';

export type TagVariant = 'good' | 'averageGood' | 'averageBad' | 'bad' | 'unknown';

interface GlobalStateTagProps {
    variant: TagVariant;
}

const variantColors: Record<TagVariant, SxProps> = {
    good: { backgroundColor: theme.color.green.light, color: theme.color.green.dark },
    averageGood: { backgroundColor: theme.color.yellow.light, color: theme.color.yellow.dark },
    averageBad: { backgroundColor: theme.color.orange.light, color: theme.color.orange.dark },
    bad: {
        backgroundColor: theme.color.red.light,
        color: theme.color.red.primary,
    },
    unknown: { backgroundColor: theme.color.grey.medium, color: theme.color.grey.dark },
};

const variantTitles: Record<TagVariant, string> = {
    good: 'labels.good',
    averageGood: 'labels.averageGood',
    averageBad: 'labels.averageBad',
    bad: 'labels.bad',
    unknown: 'labels.notScanned',
};

const buttonStyle: SxProps = {
    padding: '6px 12px',
    borderRadius: '4px',
    fontWeight: 400,
    fontSize: '13px',
    textTransform: 'none',
    maxWidth: '100%',
};

export const GlobalStateTag: FC<GlobalStateTagProps> = ({ variant }) => {
    const { t } = useTranslation();

    return (
        <Tooltip title="état global du tronçon" arrow>
            <Button sx={{ ...buttonStyle, ...variantColors[variant] }}>{t(variantTitles[variant])}</Button>
        </Tooltip>
    );
};
